// Baza danych współrzędnych polskich miast
// Format: [szerokość, długość] w stopniach dziesiętnych

export const citiesCoordinates = {
  'Warszawa': [52.2297, 21.0122],
  'Kraków': [50.0647, 19.9450],
  'Gdańsk': [54.3520, 18.6466],
  'Poznań': [52.4064, 16.9252],
  'Wrocław': [51.1079, 17.0385],
  'Łódź': [51.7592, 19.4560],
  'Katowice': [50.2649, 19.0238],
  'Lublin': [51.2465, 22.5684],
  'Białystok': [53.1325, 23.1688],
  'Szczecin': [53.4285, 14.5528],
  'Gdynia': [54.5189, 18.5305],
  'Rzeszów': [50.0412, 21.9991],
  'Bydgoszcz': [53.1235, 18.0084],
  'Olsztyn': [53.7784, 20.4801],
  'Zielona Góra': [51.9356, 15.5064],
  'Toruń': [53.0138, 18.5984],
  'Opole': [50.6751, 17.9213],
  'Kielce': [50.8661, 20.6286],
  'Tarnów': [50.0128, 20.9869],
  'Gorzów Wielkopolski': [52.7368, 15.2287],
  'Elbląg': [54.1561, 19.4045],
  'Płock': [52.5464, 19.7061],
  'Wałbrzych': [50.7706, 16.2842],
  'Włocławek': [52.6482, 19.0678],
  'Tychy': [50.1203, 18.9842],
  'Dąbrowa Górnicza': [50.3219, 19.1950],
  'Radom': [51.4025, 21.1471],
  'Sosnowiec': [50.2863, 19.1040],
  'Ruda Śląska': [50.2716, 18.8563],
  'Rybnik': [50.1022, 18.5466],
  'Gliwice': [50.3013, 18.6498],
  'Częstochowa': [50.7969, 19.1241],
  'Słupsk': [54.4641, 17.0287],
  'Jaworzno': [50.2044, 19.2739],
  'Jastrzębie-Zdrój': [49.9494, 18.5747],
  'Jelenia Góra': [50.8996, 15.7290],
  'Nowy Sącz': [49.6175, 20.7150],
  'Konin': [52.2233, 18.2512],
  'Piotrków Trybunalski': [51.4054, 19.7032],
  'Lubin': [51.4014, 16.2019],
  'Inowrocław': [52.7948, 18.2615],
  'Ostrowiec Świętokrzyski': [50.9294, 21.3856],
  'Stargard': [53.3361, 15.0499],
  'Siedlce': [52.1677, 22.2901],
  'Mysłowice': [50.2073, 19.1379],
  'Pabianice': [51.6644, 19.3547],
  'Gniezno': [52.5358, 17.5825],
  'Siemianowice Śląskie': [50.3006, 19.0276],
  'Oława': [50.9466, 17.2926],
  'Głogów': [51.6634, 16.0845],
  'Piekary Śląskie': [50.3804, 18.9265],
  'Zawiercie': [50.4877, 19.4167],
  'Legnica': [51.2076, 16.1589],
  'Tarnobrzeg': [50.5739, 21.6793],
  'Racibórz': [50.0919, 18.2192],
  'Świętochłowice': [50.2976, 18.9176],
  'Kędzierzyn-Koźle': [50.3498, 18.2261],
  'Starachowice': [51.0525, 21.0714],
  'Zgierz': [51.8556, 19.4061],
  'Bielsko-Biała': [49.8224, 19.0444],
  'Przemyśl': [49.7823, 22.7673],
  'Wodzisław Śląski': [50.0038, 18.4722],
  'Skierniewice': [51.9549, 20.1583],
  'Krosno': [49.6885, 21.7705]
};

// Funkcja pomocnicza do pobierania współrzędnych miasta
export const getCityCoordinates = (cityName) => {
  return citiesCoordinates[cityName] || [52.0, 19.0]; // Domyślnie centrum Polski
};

// Funkcja do sprawdzania czy miasto istnieje w bazie
export const isCityInDatabase = (cityName) => {
  return cityName in citiesCoordinates;
};

// Lista wszystkich miast w bazie
export const getAllCities = () => {
  return Object.keys(citiesCoordinates).sort();
};

